
import { anewSavePower, enableMountVideoScope, enableMountLiveScope, queryBindCount, dealPowerApply, savePowerBath, unbindAccount, savePower, powerRoleListData, addAuthLetter, saveIndividualClassInfo, saveInstitutionClassInfo, roleListData, roleEnter, getRole, saveBasicInfoRole } from '@/zsm-api-new/role.js'
const state = {

}

const mutations = {

}

const actions = {

  /**
   * 粉丝群重新绑定
   *  @param id 账号主键ID
   * @returns {*}
   */
  anewSavePower({ commit }, info) {
    return new Promise((resolve, reject) => {
      anewSavePower(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 短视频绑定申请
   * @param id 键值id 
   * @returns 
   */
  enableMountVideoScope({ commit }, info) {
    return new Promise((resolve, reject) => {
      enableMountVideoScope(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 短视频绑定申请
   * @param id 键值id 
   * @returns 
   */
  enableMountLiveScope({ commit }, info) {
    return new Promise((resolve, reject) => {
      enableMountLiveScope(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
 * 获取绑定数
 * @param roleEntityId 角色id
 * @returns 
 */
  queryBindCount({ commit }, info) {
    return new Promise((resolve, reject) => {
      queryBindCount(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },







  /**
 * 处理授权申请
 * @param powerApply.applyStatus 状态
 * @param id 键值id
 * @returns {*}
 */
  dealPowerApply({ commit }, info) {
    return new Promise((resolve, reject) => {
      dealPowerApply(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 解绑
  unbindAccount({ commit }, info) {
    return new Promise((resolve, reject) => {
      unbindAccount(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
  * 批量添加授权
  */
  savePowerBath({ commit }, info) {
    return new Promise((resolve, reject) => {
      savePowerBath(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
    * 添加授权
    */
  savePower({ commit }, info) {
    return new Promise((resolve, reject) => {
      savePower(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 查看授权数据
   * @param roleEntityId 角色ID
   * @returns {*}
   */
  powerRoleListData({ commit }, info) {
    return new Promise((resolve, reject) => {
      powerRoleListData(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 添加授权函
   * @param params  对象
   * @returns {*}
   */
  addAuthLetter({ commit }, info) {
    return new Promise((resolve, reject) => {
      addAuthLetter(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 保存机构类目
   * @param params  对象
   * @returns {*}
   */
  saveInstitutionClassInfo({ commit }, info) {
    return new Promise((resolve, reject) => {
      saveInstitutionClassInfo(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 保存老师类目
   * @param params  对象
   * @returns {*}
   */
  saveIndividualClassInfo({ commit }, info) {
    return new Promise((resolve, reject) => {
      saveIndividualClassInfo(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
 * 修改基本信息
 * @param params  对象
 * @returns {*}
 */

  saveBasicInfoRole({ commit }, info) {
    return new Promise((resolve, reject) => {
      saveBasicInfoRole(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 查询角色列表
   * @param id id
   * @returns {*}
   */
  getRole({ commit }, info) {
    return new Promise((resolve, reject) => {
      getRole(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 老师/机构 入驻
   * @param params  对象
   * @returns {*}
   */
  roleEnter({ commit }, info) {
    return new Promise((resolve, reject) => {
      roleEnter(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 查询角色列表
   * @param mobile 讲师手机号
   * @returns {*}
   */
  roleListData({ commit }, mobile) {
    return new Promise((resolve, reject) => {
      roleListData(mobile).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
